import React from 'react';
import { Outlet } from 'react-router-dom';
import Entete from '../Entete';
import Footer from '../Footer';

const ClientLayout = () => {
  return (
    <div className='content-page'>
       <Entete />
      <div id="content-wrapper">
        <div id="content">
          <Outlet /> {/* This will render the matched child route */}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ClientLayout;
